import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Form,
  Select,
  Space,
  DatePicker,
  Avatar,
  Badge,
  Row,
  Col,
  Input,
  Radio,
  Modal,
  Spin,
  message,
} from "antd";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { CALL_API } from "../../Common/api";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ShipmentType, TripTypeEnum } from "../../Common/constant";
import Styled from "styled-components";
import upload from "../../assets/images/upload.svg";
import filtericon from "../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import StyledTable from "../../Reusablecomponents/UITable/UITable";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Pie,
  Cell,
  PieChart,
} from "recharts";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const GreenRadio = styled(Radio)`
  .ant-radio-inner {
    border-color: green; // Change the border color
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: green; // Change the background color when checked
    border-color: green; // Change the border color when checked
  }
  .ant-radio-wrapper {
    color: green; // Change the text color
  }
`;
const Styledashboard = Styled.div`
 @media (min-width: 320px) and (max-width: 480px) {
  .overview_component {
    display: flex;
    flex-direction: column;
     align-items: flex-start!important;
  }
  .Custom{
        background-color: ;
  display: flex;
  flex-direction: column;
     align-items: flex-start!important;
  }
  .dropstyle{
 justify-content: flex-start;
  align-items: flex-start;  }
  .new_grid_content{
   overflow: hidden!important;
  }
  
 .new_grid_content{
        display:flex!important;
flex-direction: column!important;;      }
    
   
 .responsive_donutchart_container {
{
  width:100%!important;
    }
  }
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    
  }
    .timing-center {
    // margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
    // width: 84px;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .consignment-value{
  color: #1F243B;
  font-size: 24px;
  font-weight: 600;
  }
  .total-mins{
  color: #363636;
    font-size: 20px;
  font-weight: 600;
  }
  `;
const TripReports = () => {
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const { Option } = Select;
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  // const [filterModalOpen1, setFilterModalOpen1] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  // const [filterCount1, setFilterCount1] = useState(0);
  const [filterform] = Form.useForm();
  // const [filterform1] = Form.useForm();
  const [selectedReport, setSelectedReport] = useState("Trips"); // State to track selected radio button\
  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [tripChart, setTripChart] = useState([]);
  const [tripTotal, setTripTotal] = useState([]);
  const [tripData, setTripData] = useState([]);
  const [consignData, setConsignData] = useState([]);
  const [consignChart, setConsignChart] = useState([]);
  const [timeData, setTimeData] = useState([]);
  const [total, setTotal] = useState(0);
  const [consignTotal, setConsignTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [CSVList, setCSVList] = useState([]);
  const [CSVList1, setCSVList1] = useState([]);

  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const csvLinkEl2 = useRef();

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CONT_TRPT", "EX"),
    [reduxPermissions],
  );

  const vehicleOptions = vehicleList.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
  }));
  const deviceOptions = deviceList.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));
  const [filterValues, setFilterValues] = useState({
    consignee: "",
    transporter: "",
    consignor: "",
    shipment: "",
    vehicleno: "",
    consigncode: "",
    trip: "",
    triptype: "",
    devices: "",
  });
  // const [filterValues1, setFilterValues1] = useState({
  //   consignee: "",
  //   transporter: "",
  //   consignor: "",
  //   shipment: "",
  //   vehicleno: "",
  //   consigncode: "",
  //   trip: "",
  //   triptype: "",
  //   devices: "",
  //   daterange: "",
  // });
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      setDeviceList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllDevice();
    fetchAllVehicle();
  }, []);
  const getTripCard = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getContTripReporTotal?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          Receiver: filterValues?.consignee || 0,
          Triptype: filterValues?.triptype || 0,
          Tripcode: filterValues?.trip || "",
          code: filterValues?.consigncode || "",
          Device: filterValues?.devices || "",
        },
      );
      setTripTotal(data);
      setLoading(false);
      setTotal(tripTotal?.TotalTrips?.[0]?.TotalTrips ?? 0);
    } catch (error) {
      console.error("[getTripCharts] error -->", error);
    }
  };
  const getTripCharts = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getContTripReportData?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          Receiver: filterValues?.consignee || 0,
          Triptype: filterValues?.triptype || 0,
          Tripcode: filterValues?.trip || "",
          code: filterValues?.consigncode || "",
          Device: filterValues?.devices || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setTripChart(data);
      setTripData(data?.TimeReport);
      setLoading(false);
    } catch (error) {
      console.error("[getTripCharts] error -->", error);
    }
  };

  const getConsignCharts = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getContConsignReport?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          Receiver: filterValues?.consignee || 0,
          Triptype: filterValues?.triptype || 0,
          Tripcode: filterValues?.trip || "",
          code: filterValues?.consigncode || "",
          Device: filterValues?.devices || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setConsignTotal(data?.ConsignmentReportTable[0]?.TotalCount);
      setConsignData(data?.ConsignmentReportTable);
      setConsignChart(data);
      setTimeData(data?.ConsignmentLoadingTime);
      setLoading(false);
    } catch (error) {
      console.error("[getConsignCharts] error -->", error);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripCharts();
    }
  }, [filterValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripCard();
    }
  }, [filterValues, selectedDate]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getConsignCharts();
    }
  }, [filterValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  //export functionality for trip time reprt tabel
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `/contReport/getContTripReportData?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${consignTotal}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          Receiver: filterValues?.consignee || 0,
          Triptype: filterValues?.triptype || 0,
          Tripcode: filterValues?.trip || "",
          code: filterValues?.consigncode || "",
          Device: filterValues?.devices || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );

      if (data?.TimeReport?.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.TimeReport);

        setCSVList(
          sortedData?.map((item) => ({
            "Trip Code": item.Tripcode || "-",
            "Pickup Date & Time": item.PICKUPDATETIME || "-",
            Consignor: item.CUSTNAME || "-",
            Consignee: item.RECNAME || "-",
            Transporter: item.SUPNAME || "-",
            "Container Number": item.ContainerNo || "-",
            "Vehicle Carbon Footprint": item.CarbonFootprint || "-",
            "Trip Type": item.Triptype
              ? item.Triptype === 1
                ? "Local"
                : "Safari"
              : "-",
            Vehicle: item.VEHREGNO || "-",
            Driver: item?.DriverName || "",
            "ODO (KMS)": item.GPSKMS || "-",
            "Loading Waiting Time":
              formatMinutes(item.loadingwaitingtime) || "-",
            "Loading Time": formatMinutes(item.loadingtime) || "-",
            "Time After Loading": formatMinutes(item.timeafterloading) || "-",
            "Loading Cycle": formatMinutes(item.loadingCycle) || "-",
            "Offloading Waiting Time":
              formatMinutes(item.offloadingwaitingtime) || "-",
            "Offloading Time": formatMinutes(item.offloadingtime) || "-",
            "Time After Offloading":
              formatMinutes(item.timeafteroffloading) || "-",
            "Offloading Cycle": formatMinutes(item.offloadingCycle) || "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };
  //export functionality for trip time reprt tabel
  const prepareCSV1 = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `/contReport/getContConsignReport?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${consignTotal}`,
        {
          Vehid: filterValues?.vehicleno || "",
          Cust: filterValues?.consignor || 0,
          Shipper: filterValues?.transporter || 0,
          Receiver: filterValues?.consignee || 0,
          Triptype: filterValues?.triptype || 0,
          Tripcode: filterValues?.trip || "",
          code: filterValues?.consigncode || "",
          Device: filterValues?.devices || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );

      if (data?.ConsignmentReportTable[0]?.TotalCount > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting1(data?.ConsignmentReportTable);

        setCSVList1(
          sortedData?.map((item) => ({
            "Trip Code": item.code || "-",
            "Pickup Date & Time": item.pickupdatetime
              ? dayjs(item.pickupdatetime).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            Consignor: item.Custname || "-",
            Transporter: item.SUPNAME || "-",
            Consignee: item.RECNAME || "-",
            "Container Number": item.ContainerNo || "-",
            Vehicle: item.VehRegno || "-",
            "Trip Type": item.triptype
              ? item.triptype === 1
                ? "Local"
                : "Safari"
              : "-",
            "ODO (KMS)": item.GPSKMS || "-",
            "Loading Waiting Time":
              formatMinutes(item.LOADINGWAITINGTIME) || "-",
            "Loading Time": formatMinutes(item.LOADINGTIME) || "-",
            "Time After Loading": formatMinutes(item.TIMEAFTERLOADING) || "-",
            "Offloading Waiting Time":
              formatMinutes(item.OFFLOADINGWAITINGTIME) || "-",
            "Offloading Time": formatMinutes(item.OFFLOADINGTIME) || "-",
            "Time After Offloading":
              formatMinutes(item.TIMEAFTEROFFLOADING) || "-",
            "Offloading Cycle": formatMinutes(item.OFFLOADINGCYCLE) || "-",
            Locked:
              item.Locked && !item.Locked.startsWith("1900-01-01")
                ? dayjs
                    .utc(item.Locked)
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Journey Started":
              item["Journey Started"] &&
              !item["Journey Started"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Journey Started"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Arrived Pick Up Point":
              item["Arrived Pick Up Point"] &&
              !item["Arrived Pick Up Point"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Arrived Pick Up Point"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Loading Started":
              item["Loading Started"] &&
              !item["Loading Started"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Loading Started"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Loading Completed":
              item["Loading Completed"] &&
              !item["Loading Completed"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Loading Completed"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Reached Delivery Point":
              item["Reached Delivery Point"] &&
              !item["Reached Delivery Point"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Reached Delivery Point"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Offloading Started":
              item["Offloading Started"] &&
              !item["Offloading Started"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Offloading Started"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Offloading Completed":
              item["Offloading Completed"] &&
              !item["Offloading Completed"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Offloading Completed"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Return Journey Started":
              item["Return Journey Started"] &&
              !item["Return Journey Started"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Return Journey Started"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            "Return to Base":
              item["Returned to Base"] &&
              !item["Returned to Base"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Returned to Base"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
            Finished:
              item["Finished"] && !item["Finished"].startsWith("1900-01-01")
                ? dayjs
                    .utc(item["Finished"])
                    .tz("Africa/Nairobi")
                    .format("DD/MM/YYYY hh:mm A")
                : "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl2.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };

  const handleRadioChange = (e) => {
    setSelectedReport(e.target.value); // Update the selected report
  };
  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const handlechange = (value) => {
    setDuration(value);
  };
  const handlechangefordate = (date, dateString) => {
    setSelectedDate(date);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const tripStatusList = tripChart?.TripStatus ?? [];

  const localData = tripStatusList.find((t) => t.Type === "Local") || {};
  const safariData = tripStatusList.find((t) => t.Type === "Safari") || {};

  const tripStatusData = [
    {
      name: "Not Started",
      Local: localData.Loaded ?? 0,
      Safari: safariData.Loaded ?? 0,
    },
    {
      name: "In Progress",
      Local: localData.InProgress ?? 0,
      Safari: safariData.InProgress ?? 0,
    },
    {
      name: "Completed",
      Local: localData.Completed ?? 0,
      Safari: safariData.Completed ?? 0,
    },
  ];

  const timeChart = tripChart?.TimeReportChart?.[0] || {};

  // Sum all values in TimeReportChart
  const totalTimeInMinutes =
    Math.max(0, timeChart.loadingCycle ?? 0) +
    Math.max(0, timeChart.loadingtime ?? 0) +
    Math.max(0, timeChart.loadingwaitingtime ?? 0) +
    Math.max(0, timeChart.timeafterloading ?? 0) +
    Math.max(0, timeChart.offloadingCycle ?? 0) +
    Math.max(0, timeChart.offloadingtime ?? 0) +
    Math.max(0, timeChart.offloadingwaitingtime ?? 0) +
    Math.max(0, timeChart.timeafteroffloading ?? 0);

  // Round to nearest whole number to eliminate decimal noise
  const totalMinutesRounded = Math.round(totalTimeInMinutes);

  // Format
  const totalDays = Math.floor(totalMinutesRounded / (24 * 60));
  const remainingHours = Math.floor((totalMinutesRounded % (24 * 60)) / 60);
  const remainingMinutes = totalMinutesRounded % 60;

  let totalTimeFormatted;

  if (totalDays > 0) {
    totalTimeFormatted = `${totalDays}:${String(remainingHours).padStart(
      2,
      "0",
    )}:${String(remainingMinutes).padStart(2, "0")}`;
  } else {
    totalTimeFormatted = `${String(
      Math.floor(totalMinutesRounded / 60),
    ).padStart(2, "0")}:${String(remainingMinutes).padStart(2, "0")}`;
  }
  const values = [
    {
      label: "Loading Cycle",
      color: "rgb(13,178,24)",
      time: Math.max(0, timeChart.loadingCycle ?? 0),
    },
    {
      label: "Loading Time",
      color: "rgb(0,213,14)",
      time: Math.max(0, timeChart.loadingtime ?? 0),
    },
    {
      label: "Loading Wait Time",
      color: "rgb(7,247,23)",
      time: Math.max(0, timeChart.loadingwaitingtime ?? 0),
    },
    {
      label: "Time After Loading",
      color: "rgb(154,255,161)",
      time: Math.max(0, timeChart.timeafterloading ?? 0),
    },
    {
      label: "Offloading Cycle",
      color: "rgb(190,0,104)",
      time: Math.max(0, timeChart.offloadingCycle ?? 0),
    },
    {
      label: "Offloading Time",
      color: "rgb(243,0,133)",
      time: Math.max(0, timeChart.offloadingtime ?? 0),
    },
    {
      label: "Offloading Wait Time",
      color: "rgb(255,100,185)",
      time: Math.max(0, timeChart.offloadingwaitingtime ?? 0),
    },
    {
      label: "Time After Offloading",
      color: "rgb(255,161,213)",
      time: Math.max(0, timeChart.timeafteroffloading ?? 0),
    },
  ];

  const chartLegendData = values.map((item) => {
    const totalMinutes = Math.round(item.time);

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    const formattedTime =
      days > 0
        ? `${days} Day${days > 1 ? "s" : ""} ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
        : `${String(Math.floor(totalMinutes / 60)).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

    return {
      ...item,
      percentage: `${((item.time / totalTimeInMinutes) * 100).toFixed(2)}%`,
      time: formattedTime,
    };
  });

  const tripTimingData = values.map((item) => ({
    name: item.label,
    value: item.time,
    color: item.color,
  }));

  //Consignment Charts
  const totalConsignments = consignTotal;
  const chartData = consignChart?.ConsignmentStatusChart ?? [];

  const statusData = chartData.find((item) => item.Type === "Total") ?? {};

  const values1 = [
    {
      label: "Assigned",
      value: parseInt(statusData.Loaded ?? 0),
      color: "#FF5555",
    },
    {
      label: "In Progress",
      value: parseInt(statusData.InProgress ?? 0),
      color: "#FFBC41",
    },
    {
      label: "Completed",
      value: parseInt(statusData.Completed ?? 0),
      color: "#69FF78",
    },
  ];
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const RADIAN = Math.PI / 180;

    const entry = values1[index];
    if (!entry) return null;

    const startX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const startY = cy + outerRadius * Math.sin(-midAngle * RADIAN);
    const breakX = cx + (outerRadius + 20) * Math.cos(-midAngle * RADIAN);
    const breakY = cy + (outerRadius + 20) * Math.sin(-midAngle * RADIAN);
    const endX = breakX + (midAngle > 90 && midAngle < 270 ? -60 : 60);
    const endY = breakY;

    const isLeft = midAngle > 90 && midAngle < 270;
    const textOffset = isLeft ? -25 : 25;
    const textAnchor = isLeft ? "end" : "start";

    return (
      <g>
        {/* Connector line */}
        <polyline
          points={`${startX},${startY} ${breakX},${breakY} ${endX},${endY}`}
          stroke="#BEBEBE"
          strokeWidth={1}
          fill="none"
        />

        {/* Colored square */}
        <rect
          x={endX - (isLeft ? 14 : 0)}
          y={endY - 7}
          width={14}
          height={14}
          rx={2}
          ry={2}
          fill={entry.color}
        />

        {/* Label text */}
        <text
          x={endX + textOffset}
          y={endY + 5}
          textAnchor={textAnchor}
          fill="#5F6D8C"
          fontSize={14}
        >
          {`${entry.label}\u00A0\u00A0\u00A0${entry.value} (${(
            percent * 100
          ).toFixed(0)}%)`}
        </text>
      </g>
    );
  };

  const COLORS = [
    "#73BEFF",
    "#FFFA75",
    "#AFCF66",
    "#D6FF75",
    "#9AFF75",
    "#75FFA3",
    "#75F4FF",
    "#05E7DC",
    "#52B4DA",
    "#FF75D3",
  ];

  // Calculate total loading cycle for percentage basis
  const totalLoadingCycle = timeData.reduce(
    (acc, item) => acc + (item.LoadingCycle ?? 0),
    0,
  );

  const formatMinutesToHHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const loadingTimeData = timeData.map((item, index) => {
    const cycle = item.LoadingCycle ?? 0;
    const percent =
      totalLoadingCycle > 0
        ? ((cycle / totalLoadingCycle) * 100).toFixed(2)
        : "0.00";
    return {
      name: item.CONSIGNEE,
      value: cycle,
      time: formatMinutesToHHMM(cycle),
      percent,
      color: COLORS[index % COLORS.length],
    };
  });
  // Custom Label Line Renderer
  const RADIAN = Math.PI / 180;

  const renderCustomLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    percent,
    index,
    name,
    payload, // contains .fill (color) and .name
  }) => {
    const startX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const startY = cy + outerRadius * Math.sin(-midAngle * RADIAN);
    const breakX = cx + (outerRadius + 20) * Math.cos(-midAngle * RADIAN);
    const breakY = cy + (outerRadius + 20) * Math.sin(-midAngle * RADIAN);
    const endX = breakX + (midAngle > 90 && midAngle < 270 ? -60 : 60);
    const endY = breakY;

    const textAnchor = midAngle > 90 && midAngle < 270 ? "end" : "start";
    const textOffset = midAngle > 90 && midAngle < 270 ? -25 : 25; // text after dot

    return (
      <g>
        {/* Connector line */}
        <polyline
          points={`${startX},${startY} ${breakX},${breakY} ${endX},${endY}`}
          stroke="#BEBEBE"
          strokeWidth={1}
          fill="none"
        />

        {/* Colored Dot */}
        <circle
          cx={endX}
          cy={endY}
          r={8.5} // 17 / 2
          fill={payload.fill}
        />

        {/* Label Text */}
        <text
          x={endX + textOffset}
          y={endY + 5} // vertically align with circle
          textAnchor={textAnchor}
          fill="#5F6D8C"
          fontSize={14}
        >
          {`${payload.name}\u00A0\u00A0\u00A0${payload.time} (${payload.percent}%)`}
        </text>
      </g>
    );
  };
  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";

    const totalMinutes = Math.max(0, Math.round(value));

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) {
      return `${days} Day${days > 1 ? "s" : ""} ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    }

    return `${String(Math.floor(totalMinutes / 60)).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "GPSKMS",
          "CarbonFootprint",
          "loadingwaitingtime",
          "loadingtime",
          "Triptype",
          "timeafterloading",
          "loadingCycle",
          "offloadingwaitingtime",
          "offloadingtime",
          "timeafteroffloading",
          "offloadingCycle",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns = [
    {
      title: "Trip Code",
      dataIndex: "Tripcode",
      key: "Tripcode",
      sorter: (a, b) => (a.Tripcode || "").localeCompare(b.Tripcode || ""),
      sortOrder: tableSort.field === "Tripcode" ? tableSort.order : null,
    },
    {
      title: "Pick Up Date Time",
      dataIndex: "PICKUPDATETIME",
      key: "PICKUPDATETIME",
      sorter: (a, b) =>
        (a.PICKUPDATETIME || "").localeCompare(b.PICKUPDATETIME || ""),
      sortOrder: tableSort.field === "PICKUPDATETIME" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";
        const dt = dayjs.utc(value).tz("Africa/Nairobi");
        return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
      },
    },
    {
      title: "Consignor",
      dataIndex: "CUSTNAME",
      key: "CUSTNAME",
      sorter: (a, b) => (a.CUSTNAME || "").localeCompare(b.CUSTNAME || ""),
      sortOrder: tableSort.field === "CUSTNAME" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "RECNAME",
      key: "RECNAME",
      sorter: (a, b) => (a.RECNAME || "").localeCompare(b.RECNAME || ""),
      sortOrder: tableSort.field === "RECNAME" ? tableSort.order : null,
    },
    {
      title: "Transporter",
      dataIndex: "SUPNAME",
      key: "SUPNAME",
      sorter: (a, b) => (a.SUPNAME || "").localeCompare(b.SUPNAME || ""),
      sortOrder: tableSort.field === "SUPNAME" ? tableSort.order : null,
    },
    {
      title: "Container Number",
      dataIndex: "ContainerNo",
      key: "ContainerNo",
      sorter: (a, b) =>
        (a.ContainerNo || "").localeCompare(b.ContainerNo || ""),
      sortOrder: tableSort.field === "ContainerNo" ? tableSort.order : null,
    },
    {
      title: "Vehicle Carbon Footprint",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      sorter: (a, b) => (a.CarbonFootprint || 0) - (b.CarbonFootprint || 0),
      sortOrder: tableSort.field === "CarbonFootprint" ? tableSort.order : null,
      render: (value) => (value != null ? value : "-"),
    },
    {
      title: "Trip Type",
      dataIndex: "Triptype",
      key: "Triptype",
      sorter: (a, b) => (a.Triptype || 0) - (b.Triptype || 0),
      sortOrder: tableSort.field === "Triptype" ? tableSort.order : null,
      render: (value) => (value === 1 ? "Local" : "Safari"),
    },
    {
      title: "ODO (KMS)",
      dataIndex: "GPSKMS",
      key: "GPSKMS",
      sorter: (a, b) => (a.GPSKMS || 0) - (b.GPSKMS || 0),
      sortOrder: tableSort.field === "GPSKMS" ? tableSort.order : null,
      render: (value) => (value != null ? value : "-"),
    },
    {
      title: "Loading Waiting Time",
      dataIndex: "loadingwaitingtime",
      key: "loadingwaitingtime",
      sorter: (a, b) =>
        (a.loadingwaitingtime || 0) - (b.loadingwaitingtime || 0),
      sortOrder:
        tableSort.field === "loadingwaitingtime" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Loading Time",
      dataIndex: "loadingtime",
      key: "loadingtime",
      sorter: (a, b) => (a.loadingtime || 0) - (b.loadingtime || 0),
      sortOrder: tableSort.field === "loadingtime" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Time After Loading",
      dataIndex: "timeafterloading",
      key: "timeafterloading",
      sorter: (a, b) => (a.timeafterloading || 0) - (b.timeafterloading || 0),
      sortOrder:
        tableSort.field === "timeafterloading" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Loading Cycle",
      dataIndex: "loadingCycle",
      key: "loadingCycle",
      sorter: (a, b) => (a.loadingCycle || 0) - (b.loadingCycle || 0),
      sortOrder: tableSort.field === "loadingCycle" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Waiting Time",
      dataIndex: "offloadingwaitingtime",
      key: "offloadingwaitingtime",
      sorter: (a, b) =>
        (a.offloadingwaitingtime || 0) - (b.offloadingwaitingtime || 0),
      sortOrder:
        tableSort.field === "offloadingwaitingtime" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Time",
      dataIndex: "offloadingtime",
      key: "offloadingtime",
      sorter: (a, b) => (a.offloadingtime || 0) - (b.offloadingtime || 0),
      sortOrder: tableSort.field === "offloadingtime" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Time After Offloading",
      dataIndex: "timeafteroffloading",
      key: "timeafteroffloading",
      sorter: (a, b) =>
        (a.timeafteroffloading || 0) - (b.timeafteroffloading || 0),
      sortOrder:
        tableSort.field === "timeafteroffloading" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Cycle",
      dataIndex: "offloadingCycle",
      key: "offloadingCycle",
      sorter: (a, b) => (a.offloadingCycle || 0) - (b.offloadingCycle || 0),
      sortOrder: tableSort.field === "offloadingCycle" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
  ];

  const [tableSort1, setTableSort1] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting1 = (data) => {
    if (!tableSort1.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort1.field];
      let bVal = b[tableSort1.field];

      // Handle numeric fields
      if (
        [
          "GPSKMS",
          "TIMEAFTERLOADING",
          "LOADINGWAITINGTIME",
          "LOADINGTIME",
          "triptype",
          "OFFLOADINGWAITINGTIME",
          "OFFLOADINGTIME",
          "TIMEAFTEROFFLOADING",
          "OFFLOADINGCYCLE",
          "Locked",
          "Journey Started",
          "Arrived Pickup Point",
          "Loading Started",
          "Loading Completed",
          "Reached Delivery Point",
          "Offloading Started",
          "Offloading Completed",
          "Return Journey Started",
          "Returned To Base",
          "Finished",
        ].includes(tableSort1.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort1.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort1.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns1 = [
    {
      title: "Trip Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code || "").localeCompare(b.code || ""),
      sortOrder: tableSort1.field === "code" ? tableSort1.order : null,
    },
    {
      title: "Pick Up Date Time",
      dataIndex: "pickupdatetime",
      key: "pickupdatetime",
      sorter: (a, b) =>
        (a.pickupdatetime || "").localeCompare(b.pickupdatetime || ""),
      sortOrder:
        tableSort1.field === "pickupdatetime" ? tableSort1.order : null,
      render: (value) => {
        if (!value) return "-";
        const dt = dayjs.utc(value).tz("Africa/Nairobi");
        return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
      },
    },
    {
      title: "Vehicle",
      dataIndex: "VehRegno",
      key: "VehRegno",
      sorter: (a, b) => (a.VehRegno || "").localeCompare(b.VehRegno || ""),
      sortOrder: tableSort1.field === "VehRegno" ? tableSort1.order : null,
    },
    {
      title: "Container Number",
      dataIndex: "ContainerNo",
      key: "ContainerNo",
      sorter: (a, b) =>
        (a.ContainerNo || "").localeCompare(b.ContainerNo || ""),
      sortOrder: tableSort1.field === "ContainerNo" ? tableSort1.order : null,
    },
    {
      title: "Consignor",
      dataIndex: "Custname",
      key: "Custname",
      sorter: (a, b) => (a.Custname || "").localeCompare(b.Custname || ""),
      sortOrder: tableSort1.field === "Custname" ? tableSort1.order : null,
    },
    {
      title: "Transporter",
      dataIndex: "SUPNAME",
      key: "SUPNAME",
      sorter: (a, b) => (a.SUPNAME || "").localeCompare(b.SUPNAME || ""),
      sortOrder: tableSort1.field === "SUPNAME" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "RECNAME",
      key: "RECNAME",
      sorter: (a, b) => (a.RECNAME || "").localeCompare(b.RECNAME || ""),
      sortOrder: tableSort1.field === "RECNAME" ? tableSort1.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "triptype",
      key: "triptype",
      sorter: (a, b) => (a.triptype || 0) - (b.triptype || 0),
      sortOrder: tableSort.field === "triptype" ? tableSort1.order : null,
      render: (value) => (value === 1 ? "Local" : "Safari"),
    },
    {
      title: "ODO (KMS)",
      dataIndex: "GPSKMS",
      key: "GPSKMS",
      sorter: (a, b) => (a.GPSKMS || 0) - (b.GPSKMS || 0),
      sortOrder: tableSort1.field === "GPSKMS" ? tableSort1.order : null,
      render: (value) => (value != null ? value : "-"),
    },
    {
      title: "Loading Waiting Time",
      dataIndex: "LOADINGWAITINGTIME",
      key: "LOADINGWAITINGTIME",
      sorter: (a, b) =>
        (a.LOADINGWAITINGTIME || 0) - (b.LOADINGWAITINGTIME || 0),
      sortOrder:
        tableSort1.field === "LOADINGWAITINGTIME" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Loading Time",
      dataIndex: "LOADINGTIME",
      key: "LOADINGTIME",
      sorter: (a, b) => (a.LOADINGTIME || 0) - (b.LOADINGTIME || 0),
      sortOrder: tableSort1.field === "LOADINGTIME" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Time After Loading",
      dataIndex: "TIMEAFTERLOADING",
      key: "TIMEAFTERLOADING",
      sorter: (a, b) => (a.TIMEAFTERLOADING || 0) - (b.TIMEAFTERLOADING || 0),
      sortOrder:
        tableSort1.field === "TIMEAFTERLOADING" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Waiting Time",
      dataIndex: "OFFLOADINGWAITINGTIME",
      key: "OFFLOADINGWAITINGTIME",
      sorter: (a, b) =>
        (a.OFFLOADINGWAITINGTIME || 0) - (b.OFFLOADINGWAITINGTIME || 0),
      sortOrder:
        tableSort1.field === "OFFLOADINGWAITINGTIME" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Time",
      dataIndex: "OFFLOADINGTIME",
      key: "OFFLOADINGTIME",
      sorter: (a, b) => (a.OFFLOADINGTIME || 0) - (b.OFFLOADINGTIME || 0),
      sortOrder:
        tableSort1.field === "OFFLOADINGTIME" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Time After Offloading",
      dataIndex: "TIMEAFTEROFFLOADING",
      key: "TIMEAFTEROFFLOADING",
      sorter: (a, b) =>
        (a.TIMEAFTEROFFLOADING || 0) - (b.TIMEAFTEROFFLOADING || 0),
      sortOrder:
        tableSort1.field === "TIMEAFTEROFFLOADING" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Offloading Cycle",
      dataIndex: "OFFLOADINGCYCLE",
      key: "OFFLOADINGCYCLE",
      sorter: (a, b) => (a.OFFLOADINGCYCLE || 0) - (b.OFFLOADINGCYCLE || 0),
      sortOrder:
        tableSort1.field === "OFFLOADINGCYCLE" ? tableSort1.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Locked",
      dataIndex: "Locked",
      key: "Locked",
      sorter: (a, b) => (a.Locked || "").localeCompare(b.Locked || ""),
      sortOrder: tableSort1.field === "Locked" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Journey Started",
      dataIndex: "Journey Started",
      key: "Journey Started",
      sorter: (a, b) =>
        (a["Journey Started"] || "").localeCompare(b["Journey Started"] || ""),
      sortOrder:
        tableSort1.field === "Journey Started" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Arrived Pick Up Point",
      dataIndex: "Arrived Pickup Point",
      key: "Arrived Pickup Point",
      sorter: (a, b) =>
        (a["Arrived Pickup Point"] || "").localeCompare(
          b["Arrived Pickup Point"] || "",
        ),
      sortOrder:
        tableSort1.field === "Arrived Pickup Point" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Loading Started",
      dataIndex: "Loading Started",
      key: "Loading Started",
      sorter: (a, b) =>
        (a["Loading Started"] || "").localeCompare(b["Loading Started"] || ""),
      sortOrder:
        tableSort1.field === "Loading Started" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Loading Completed",
      dataIndex: "Loading Completed",
      key: "Loading Completed",
      sorter: (a, b) =>
        (a["Loading Completed"] || "").localeCompare(
          b["Loading Completed"] || "",
        ),
      sortOrder:
        tableSort1.field === "Loading Completed" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Reached Delivery Point",
      dataIndex: "Reached Delivery Point",
      key: "Reached Delivery Point",
      sorter: (a, b) =>
        (a["Reached Delivery Point"] || "").localeCompare(
          b["Reached Delivery Point"] || "",
        ),
      sortOrder:
        tableSort1.field === "Reached Delivery Point" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Offloading Started",
      dataIndex: "Offloading Started",
      key: "Offloading Started",
      sorter: (a, b) =>
        (a["Offloading Started"] || "").localeCompare(
          b["Offloading Started"] || "",
        ),
      sortOrder:
        tableSort1.field === "Offloading Started" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Offloading Completed",
      dataIndex: "Offloading Completed",
      key: "Offloading Completed",
      sorter: (a, b) =>
        (a["Offloading Completed"] || "").localeCompare(
          b["Offloading Completed"] || "",
        ),
      sortOrder:
        tableSort1.field === "Offloading Completed" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Return Journey Started",
      dataIndex: "Return Journey Started",
      key: "Return Journey Started",
      sorter: (a, b) =>
        (a["Return Journey Started"] || "").localeCompare(
          b["Return Journey Started"] || "",
        ),
      sortOrder:
        tableSort1.field === "Return Journey Started" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    // {
    //   title: "Delivery Journey Started",
    //   dataIndex: "Delivery Journey Started",
    //   key: "Delivery Journey Started",
    //       render: (text) => {
    //   if (
    //     !text ||
    //     text.startsWith("1900-01-01") // treat default sentinel as null
    //   ) {
    //     return "-";
    //   }
    //   return dayjs.utc(text).tz("Africa/Nairobi").format("DD/MM/YYYY hh:mm A");
    // },
    {
      title: "Return to Base",
      dataIndex: "Returned To Base",
      key: "Returned To Base",
      sorter: (a, b) =>
        (a["Returned To Base"] || "").localeCompare(
          b["Returned To Base"] || "",
        ),
      sortOrder:
        tableSort1.field === "Returned To Base" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
    {
      title: "Finished",
      dataIndex: "Finished",
      key: "Finished",
      sorter: (a, b) => (a.Finished || "").localeCompare(b.Finished || ""),
      sortOrder: tableSort1.field === "Finished" ? tableSort1.order : null,
      render: (text) => {
        if (
          !text ||
          text.startsWith("1900-01-01") // treat default sentinel as null
        ) {
          return "-";
        }
        return dayjs
          .utc(text)
          .tz("Africa/Nairobi")
          .format("DD/MM/YYYY hh:mm A");
      },
    },
  ];
  const totalTrips = tripTotal?.TotalTrips?.[0]?.TotalTrips ?? 0;
  const importTrips = tripTotal?.ImportTrips?.[0]?.ImportTrips ?? 0;
  const exportTrips = tripTotal?.ExportTrips?.[0]?.ExportTrips ?? 0;

  const importPercentage = totalTrips
    ? ((importTrips / totalTrips) * 100).toFixed(0)
    : 0;
  const exportPercentage = totalTrips
    ? ((exportTrips / totalTrips) * 100).toFixed(0)
    : 0;

  return (
    <Styledashboard>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              setFilterValues({
                consignee: "",
                transporter: "",
                consignor: "",
                shipment: "",
                vehicleno: "",
                consigncode: "",
                trip: "",
                triptype: "",
                devices: "",
              }); // Reset the state
              filterform?.setFieldsValue({
                consignee: "",
                transporter: "",
                consignor: "",
                shipment: "",
                vehicleno: "",
                consigncode: "",
                trip: "",
                triptype: "",
                devices: "",
              });
              setFilterCount(0);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>

        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            const count = Object.values(allvalues).filter(
              (val) =>
                val !== undefined && val !== null && String(val).trim() !== "",
            ).length;

            setFilterCount(count);
            setFilterValues(allvalues);
          }}
          initialValues={filterValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="View Data by" name="type">
                <Radio.Group
                  onChange={handleRadioChange}
                  value={selectedReport}
                >
                  <GreenRadio value="Trips">Trips</GreenRadio>
                  <GreenRadio value="Consignments">Consignments</GreenRadio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle No" name="vehicleno">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={vehicleOptions}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="consignor">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="transporter">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Shipment Type" name="shipment">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={ShipmentType?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consign Code" name="consigncode">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip" name="trip">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip Type" name="triptype">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={TripTypeEnum?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Device" name="devices">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={deviceOptions}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* Conditional Content */}
      {selectedReport === "Trips" ? (
        <div>
          <div
            className="total overview_component"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center", // Align items vertically
              width: "100%",
            }}
          >
            {/* Overview on the left */}
            <div className="head" style={{ flex: 1 }}>
              Overview
            </div>

            {/* Duration and Date Range on the right */}
            <div className="Custom" style={{ display: "flex", gap: "20px" }}>
              <div className="dropstyle">
                <Form.Item
                  label=""
                  name="dropdown"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Custom Range"
                    onChange={handlechange}
                    defaultValue={duration}
                    className="plc"
                  >
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="dropstyle1">
                <Space direction="vertical" size={12}>
                  <RangePicker
                    value={selectedDate}
                    onChange={handlechangefordate}
                  />
                </Space>
              </div>
              <div>
                <Badge
                  count={filterCount}
                  className="badg"
                  onClick={() => setFilterModalOpen(true)}
                >
                  <Avatar
                    shape="circle"
                    size="medium"
                    src={filtericon}
                    className="filterstyle"
                  />
                </Badge>
              </div>
            </div>
          </div>

          <Spin spinning={loading}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#F9F9F9", // Light background color
                padding: "20px 30px", // Add padding for spacing
                borderRadius: "8px", // Rounded corners
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow
              }}
            >
              {/* Total No. of Trips */}
              <div style={{ textAlign: "center", flex: 1 }}>
                <div
                  style={{
                    fontSize: "18px",
                    color: "#363636",
                    marginBottom: "8px",
                  }}
                >
                  Total No. of Trips
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#101010",
                  }}
                >
                  {totalTrips}
                </div>
              </div>

              {/* Divider */}
              <div
                style={{
                  width: "1px",
                  height: "50px",
                  backgroundColor: "#E0E0E0",
                  margin: "0 20px",
                }}
              ></div>

              {/* Import */}
              <div style={{ textAlign: "center", flex: 1 }}>
                <div
                  style={{
                    fontSize: "18px",
                    color: "#363636",
                    marginBottom: "8px",
                  }}
                >
                  Import
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#101010",
                  }}
                >
                  {importTrips}
                </div>
                <div style={{ fontSize: "14px", color: "#5F6D8C" }}>
                  {importPercentage}%
                </div>
              </div>

              {/* Divider */}
              <div
                style={{
                  width: "1px",
                  height: "50px",
                  backgroundColor: "#E0E0E0",
                  margin: "0 20px",
                }}
              ></div>

              {/* Export */}
              <div style={{ textAlign: "center", flex: 1 }}>
                <div
                  style={{
                    fontSize: "18px",
                    color: "#363636",
                    marginBottom: "8px",
                  }}
                >
                  Export
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#101010",
                  }}
                >
                  {exportTrips}
                </div>
                <div style={{ fontSize: "14px", color: "#5F6D8C" }}>
                  {exportPercentage}%
                </div>
              </div>
            </div>
          </Spin>
          <Spin spinning={loading}>
            <div id="Export Chart">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                  marginTop: "30px",
                  flexWrap: "wrap", // Allows wrapping on smaller screens
                }}
              >
                {/* Bar Chart Card */}
                <div
                  style={{
                    flex: "1 1 500px", // Grow/Shrink and min width
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    padding: "20px",
                    maxWidth: "100%", // Prevent overflow
                  }}
                >
                  <div
                    className="chart-header"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <p
                      className="pb-0 mb-0"
                      style={{ fontWeight: 500, fontSize: "16px" }}
                    >
                      Trip Status
                    </p>
                    {/* <Tooltip title={exportAllowed ? "Export" : "No permission"}> */}
                    <span
                      style={{
                        display: "inline-block",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart", "Trip Status");
                      }}
                    >
                      <img
                        src={ExportIcon}
                        alt="Export"
                        style={{
                          width: "20px",
                          height: "20px",
                          backgroundColor: "#EBF7ED",
                          borderRadius: "6px",
                        }}
                      />
                    </span>
                    {/* </Tooltip> */}
                  </div>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      layout="vertical"
                      data={tripStatusData}
                      margin={{ top: 50, right: 20, left: -10, bottom: 5 }}
                      barCategoryGap="10%"
                    >
                      <Legend verticalAlign="top" align="right" />
                      <Tooltip />
                      <XAxis type="number" tickLine={false} axisLine={false} />
                      <YAxis
                        dataKey="name"
                        type="category"
                        width={150}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Bar dataKey="Safari" stackId="a" fill="#FFD464" />
                      <Bar dataKey="Local" stackId="a" fill="#7064F5" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>

            <div id="Export Chart1">
              {/* Pie Chart Card */}
              <div
                style={{
                  flex: "1 1 500px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "100%",
                }}
              >
                <div
                  className="chart-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="pb-0 mb-0"
                    style={{ fontWeight: 500, fontSize: "16px" }}
                  >
                    Trip Timing
                  </p>
                  {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart("Export Chart1", "Trip Timing");
                    }}
                  />
                  {/* </Tooltip> */}
                </div>
                <div
                  className="donut_chart"
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "250px",
                    marginTop: "60px",
                  }}
                >
                  <ResponsiveContainer
                    className="responsive_donutchart_container"
                    width="100%"
                    height="100%"
                  >
                    <PieChart className="container_forpiechart">
                      <Pie
                        data={tripTimingData}
                        startAngle={180}
                        endAngle={0}
                        innerRadius={80}
                        outerRadius={window.innerWidth === 320 ? 100 : 140}
                        dataKey="value"
                        cx="50%"
                        cy="65%"
                      >
                        {tripTimingData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>

                  {/* Centered Total Time */}
                  <div
                    style={{
                      position: "absolute",
                      top: "55%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      pointerEvents: "none",
                    }}
                  >
                    <div className="text-gray-400 text-sm">Total Time</div>
                    <div className="total-mins">
                      {totalTimeFormatted}{" "}
                      {totalDays > 0 ? "(Days:Hr:Min)" : "(Hr:Min)"}{" "}
                    </div>
                  </div>
                </div>

                {/* Legend in 2 Columns & 4 Rows */}
                <div
                  className="new_grid_content"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "10px",
                    marginTop: "-30px",
                  }}
                >
                  {chartLegendData.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "17px",
                          height: "17px",
                          borderRadius: "50%",
                          backgroundColor: item.color,
                        }}
                      ></div>
                      <div style={{ flex: 1 }}>{item.label}</div>
                      <div>
                        {item.time} ({item.percentage})
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Spin>

          <br />
          <div className="header-container">
            <div className="head">{consignTotal} records found.</div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Spin spinning={CSVLoader}>
                {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                <img
                  src={ExportIcon}
                  style={{
                    cursor: exportAllowed ? "pointer" : "not-allowed",
                  }}
                  alt="Upload Icon"
                  className="hover-image"
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV();
                  }}
                />
                {/* </Tooltip> */}
              </Spin>
              <CSVLink
                data={CSVList}
                filename={"TripTimeReport.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
            </div>
          </div>
          <br />

          <div>
            <Spin spinning={loading}>
              <StyledTable
                dataSource={tripData}
                columns={columns}
                pagination={false}
                onChange={(pagination, filters, sorter) => {
                  setTableSort({
                    field: sorter.field,
                    order: sorter.order,
                  });
                }}
              />
            </Spin>
          </div>
        </div>
      ) : (
        //Consignment Reports
        <div>
          <div
            className="total"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center", // Align items vertically
              width: "100%",
            }}
          >
            {/* Overview on the left */}
            <div className="head" style={{ flex: 1 }}>
              Chart View
            </div>

            {/* Duration and Date Range on the right */}
            <div className="Custom" style={{ display: "flex", gap: "20px" }}>
              <div className="dropstyle">
                <Form.Item
                  label=""
                  name="dropdown"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Custom Range"
                    onChange={handlechange}
                    defaultValue={duration}
                    className="plc"
                  >
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="dropstyle1">
                <Space direction="vertical" size={12}>
                  <RangePicker
                    value={selectedDate}
                    onChange={handlechangefordate}
                  />
                </Space>
              </div>
              <div>
                <Badge
                  count={filterCount}
                  className="badg"
                  onClick={() => setFilterModalOpen(true)}
                >
                  <Avatar
                    shape="circle"
                    size="medium"
                    src={filtericon}
                    className="filterstyle"
                  />
                </Badge>
              </div>
            </div>
          </div>

          <div id="Export Chart2">
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                border: "#E7E7ED 1px solid",
                borderRadius: "8px",
              }}
            >
              {/* Title and Export Icon Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <p
                  className="pb-0 mb-0"
                  style={{ fontWeight: 500, fontSize: "16px", margin: 0 }}
                >
                  Consignment Status
                </p>
                {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{
                    cursor: exportAllowed ? "pointer" : "not-allowed", // optional for spacing
                  }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart2", "Consignment Status");
                  }}
                />
                {/* </Tooltip> */}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {/* Pie Chart */}
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={values1}
                      startAngle={180}
                      endAngle={0}
                      innerRadius={100}
                      outerRadius={160}
                      dataKey="value"
                      cx="50%"
                      cy="65%"
                      labelLine={false}
                      label={renderCustomizedLabel}
                    >
                      {values1.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Centered Total Consignments */}
              <div
                style={{
                  position: "absolute",
                  top: "75%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  pointerEvents: "none",
                }}
              >
                <div className="text-gray-400 text-sm">Total Consignments</div>
                <div className="consignment-value">{totalConsignments}</div>
              </div>
            </div>
          </div>
          <br />

          <div id="Export Chart3">
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "600px",
                border: "#E7E7ED 1px solid",
                borderRadius: "8px",
              }}
            >
              {/* Title and Export Icon Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <p
                  className="pb-0 mb-0"
                  style={{ fontWeight: 500, fontSize: "16px", margin: 0 }}
                >
                  Loading Time
                </p>
                {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{
                    cursor: exportAllowed ? "pointer" : "not-allowed", // optional for spacing
                  }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart3", "Loading Time");
                  }}
                />
                {/* </Tooltip> */}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={loadingTimeData}
                      cx="50%"
                      cy="35%"
                      innerRadius={100}
                      outerRadius={150}
                      dataKey="value"
                      labelLine={false}
                      label={renderCustomLabel}
                    >
                      {loadingTimeData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="header-container">
            <div className="head">{consignTotal} records found.</div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Spin spinning={CSVLoader}>
                {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                <img
                  src={ExportIcon}
                  alt="Upload Icon"
                  style={{
                    cursor: exportAllowed ? "pointer" : "not-allowed",
                  }}
                  className="hover-image"
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV1();
                  }}
                />
                {/* </Tooltip> */}
              </Spin>
              <CSVLink
                data={CSVList1}
                filename={"Consignment_Reports.csv"}
                asyncOnClick={true}
                ref={csvLinkEl2}
              />
            </div>
          </div>
          <br />
          <div>
            <StyledTable
              dataSource={consignData}
              columns={columns1}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                setTableSort1({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
          </div>
        </div>
      )}
      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        total={consignTotal}
        handlePageChange={handlePageChange}
      />
    </Styledashboard>
  );
};

export default TripReports;
